module.exports = __webpack_public_path__ + "static/media/Slide-01.7376781b.jpg";